export default [
  {
    name: "Week 1",
    startDate: "2025-02-22",
    endDate: "2025-02-23",
  },
  {
    name: "Week 2",
    startDate: "2025-03-01",
    endDate: "2025-03-02",
  },
  {
    name: "Week 3",
    startDate: "2025-03-08",
    endDate: "2025-03-09",
  },
  {
    name: "Week 4",
    startDate: "2025-03-15",
    endDate: "2025-03-16",
  },
  {
    name: "Week 5",
    startDate: "2025-03-22",
    endDate: "2025-03-23",
  },
  {
    name: "Week 6",
    startDate: "2025-03-29",
    endDate: "2025-03-30",
  },
  {
    name: "Week 7",
    startDate: "2025-04-05",
    endDate: "2025-04-06",
  },
  {
    name: "Week 8",
    startDate: "2025-04-12",
    endDate: "2025-04-13",
  },
  {
    name: "Week 9",
    startDate: "2025-04-19",
    endDate: "2025-04-20",
  },
  {
    name: "Week 10",
    startDate: "2025-04-26",
    endDate: "2025-04-27",
  },
  {
    name: "Week 11",
    startDate: "2025-05-03",
    endDate: "2025-05-04",
  },
  {
    name: "Week 12",
    startDate: "2025-05-10",
    endDate: "2025-05-11",
  },
  {
    name: "Week 13",
    startDate: "2025-05-14",
    endDate: "2025-05-18",
  },
  {
    name: "Week 14",
    startDate: "2025-05-24",
    endDate: "2025-05-25",
  },
  {
    name: "Week 15",
    startDate: "2025-05-28",
    endDate: "2025-06-01",
  },
  {
    name: "Week 16",
    startDate: "2025-06-07",
    endDate: "2025-06-08",
  },
  {
    name: "Week 17",
    startDate: "2025-06-12",
    endDate: "2025-06-15",
  },
  {
    name: "Week 18",
    startDate: "2025-06-25",
    endDate: "2025-06-29",
  },
  {
    name: "Week 19",
    startDate: "2025-07-03",
    endDate: "2025-07-06",
  },
  {
    name: "Week 20",
    startDate: "2025-07-09",
    endDate: "2025-07-13",
  },
  {
    name: "Week 21",
    startDate: "2025-07-16",
    endDate: "2025-07-20",
  },
  {
    name: "Week 22",
    startDate: "2025-07-25",
    endDate: "2025-07-27",
  },
  {
    name: "Week 23",
    startDate: "2025-08-09",
    endDate: "2025-08-10",
  },
  {
    name: "Week 24",
    startDate: "2025-08-16",
    endDate: "2025-08-17",
  },
  {
    name: "Week 25",
    startDate: "2025-08-23",
    endDate: "2025-08-24",
  },
  {
    name: "Week 26",
    startDate: "2025-08-30",
    endDate: "2025-08-31",
  },
  {
    name: "Week 27",
    startDate: "2025-09-06",
    endDate: "2025-09-07",
  },
  {
    name: "Week 28",
    startDate: "2025-09-13",
    endDate: "2025-09-14",
  },
  {
    name: "Week 29",
    startDate: "2025-09-16",
    endDate: "2025-09-21",
  },
  {
    name: "Week 30",
    startDate: "2025-09-24",
    endDate: "2025-09-28",
  },
  {
    name: "Week 31",
    startDate: "2025-10-04",
    endDate: "2025-10-05",
  },
  {
    name: "Week 32",
    startDate: "2025-10-18",
    endDate: "2025-10-19",
  },
  // TODO: Add these when they are announced
  // {
  //   name: "Wild Card",
  //   startDate: "2025-10-25",
  //   endDate: "2025-10-27",
  // },
  // {
  //   name: "Round One - First Leg",
  //   startDate: "2025-10-25",
  //   endDate: "2025-10-29",
  // },
  // {
  //   name: "Round One - Second Leg",
  //   startDate: "2025-11-01",
  //   endDate: "2025-11-03",
  // },
  // {
  //   name: "Round One - Third Leg",
  //   startDate: "2025-11-08",
  //   endDate: "2025-11-10",
  // },
  // {
  //   name: "Conf Semifinals",
  //   startDate: "2025-11-23",
  //   endDate: "2025-11-24",
  // },
  // {
  //   name: "Conf Finals",
  //   startDate: "2025-11-30",
  //   endDate: "2025-12-01",
  // },
  // {
  //   name: "MLS Cup",
  //   startDate: "2025-12-07",
  //   endDate: "2025-12-08",
  // },
];
